import axios from "axios";
import { GET_ORDERS, GET_ORDERS_CALCULATIONS, SET_TOTAL_ACCEPTED_ORDERS, SET_TOTAL_COMPLETED_ORDERS, SET_TOTAL_IN_PROGRESS_ORDERS, SET_TOTAL_ORDERS, SET_TOTAL_PENDING_ORDERS, SET_TOTAL_REJECTED_ORDERS } from "../utilities/constants";

export const getOrders = () => async (dispatch) => {
  const res = await axios.get("/api/orders");
  const orders = await res.data;
  if (orders !== null) {
    dispatch({
      type: GET_ORDERS,
      payload: orders,
    });
  }
};

export const getOrdersCalculations = async (country) => {
  const inputCountry = country.toLowerCase() === 'canada' ? 'Canada' : 'United States';
  try {
    const res = await axios.get(`/api/calculations/orders/count-by-country?country=${inputCountry}`);
    const { count, pendingOrders, acceptedOrders, startedOrders, completedOrders, rejectedOrders } = res.data;
    return { count, pendingOrders, acceptedOrders, startedOrders, completedOrders, rejectedOrders };
  } catch (error) {
    console.error(error);
  }
};
